<template>
    <Dialog
        v-model:visible="visible"
        :style="{ width: '550px' }"
        header="Block Details"
        :modal="true"
        maximizable
        :dismissableMask="true"
        @hide="$emit('hide-dialog', true)"
    >
        <div class="surface-section">
            <ul class="list-none p-0 m-0 surface-container">
                <li class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Id</div>
                    <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ block.id }}</div>
                </li>
                <li class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Version</div>
                    <div
                        class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1"
                    >{{ block.version }}</div>
                </li>
                <li v-if="block.category_id" class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Category</div>
                    <div
                        class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1"
                    >{{ block.category_id }}</div>
                </li>
                <li class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Code</div>
                    <div
                        class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1"
                    >{{ block.code }}</div>
                </li>
                <li class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Description</div>
                    <div
                        class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1"
                    >{{ block.description }}</div>
                </li>
                <li class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Default</div>
                    <div
                        class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1"
                    >{{ block.default }}</div>
                </li>
            </ul>
            <Divider />
            <div class="text-900 text-center">Block Attributes</div>
            <Divider />
            <div
                v-if="block.attributes && block.attributes.length <= 0"
            >Block doesnt have attributes</div>
            <div
                v-else
                class="py-3 px-2 border-bottom-1 surface-border"
                v-for="item in block.attributes"
                :key="item.id"
            >
                <div class="w-full">
                    <display-type
                        :type="parseInt(item.type)"
                        :placeholder="item.placeholder"
                        :options="item.options"
                        :label="item.label"
                    />
                </div>
            </div>
        </div>
    </Dialog>
</template>

<script>
import DisplayType from '../input-type/DisplayType.vue';
export default {
	name: 'BlockDetails',
	components: { DisplayType },
	props: {
		block: {
			type: Object,
		},
	},
	data() {
		return {
			visible: true,
		};
	},
};
</script>

<style scoped>
.surface-section > .surface-container {
	overflow-y: auto;
}
li {
	display: flex;
	flex-direction: row;
}
li > div {
	display: flex;
	justify-content: left;
	align-items: center;
}
li > div:nth-child(odd) {
	width: 30% !important;
}
li > div:nth-child(even) {
	width: 70% !important;
}
</style>
